// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
import { handleServerCookie } from '../cookie/handle-server-cookie';
import { createSettings } from '../settings/create-settings';
import { debug } from '../debug/debug';
import { CORE_NAMESPACE } from '../debug/namespaces';
/**
 * Internal settings object to be used by all functions in module caching.
 * It starts with a null value and is set to the proper object by the  function. *
 * Can be retrieved only through the  function.
 */
let coreSettings = null;
export function setCoreSettings(settings) {
    coreSettings = settings;
}
/**
 * Initializes the core settings for browser-based applications.
 *
 * This function initializes core settings for the application, including creating settings and handling cookies if enabled.
 *
 * @param settingsInput - The settings input to configure the core settings.
 * @returns A Promise that resolves when initialization is complete.
 */
export function getSettingsServer() {
    if (!coreSettings) {
        throw Error('[IE-0008] You must first initialize the "core" package. Run the "init" function.');
    }
    return coreSettings;
}
/**
 * Initializes the core settings for browser-based applications.
 *
 * This function initializes core settings for the application, including creating settings and handling cookies if enabled.
 *
 * @param settingsInput - The settings input to configure the core settings.
 * @param request - A request object of type HttpRequest or MiddlewareRequest
 * @param response - A response object of type HttpResponse or MiddlewareNextResponse
 * @returns A Promise that resolves when initialization is complete.
 */
export async function initCoreServer(settingsInput, request, response) {
    debug(CORE_NAMESPACE)('initializing %o', 'initCoreServer initialized');
    if (!coreSettings)
        coreSettings = createSettings(settingsInput);
    if (settingsInput.enableServerCookie) {
        await handleServerCookie(request, response, settingsInput.timeout);
    }
}
